import React from 'react'
import styled from 'styled-components'

const Column = styled.div`
    flex-grow: 1;
    line-height: 2rem;
`
const TriColumn = ({ children }) => <Column>{children}</Column>

export default TriColumn
